import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  useNotification,
  getErrorNotification,
} from '@components/Notification';

import ParticipantsService from '@services/ParticipantsService';
import { restoringFocusDownload } from '@helpers/screenshotCanvas';

const useGoldenTicket = () => {
  const { showNotification } = useNotification();
  const { t: translate } = useTranslation();

  const downloadBackendTicket = useCallback(async () => {
    try {
      const response = await ParticipantsService.getParticipantGoldenTicket();

      const blob = new Blob([response.data], { type: 'image/png' });
      const imageUrl = URL.createObjectURL(blob);

      restoringFocusDownload(imageUrl, 'golden-ticket.png');
    } catch (error) {
      console.log('error', error);
      showNotification(
        getErrorNotification({
          message: translate('notifications.download.goldenTicketError'),
        }),
      );
    }
  }, []);

  return { downloadBackendTicket };
};

export default useGoldenTicket;
